import { Draggable } from "@hello-pangea/dnd";
import { Dropdown, Spinner } from "@swivl-mono/ui";
import UserVariablesDropdown from "../../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import React from "react";
import { FaBars, FaMinusCircle } from "react-icons/fa";


export default class InspectorButton extends React.Component<any>{
    constructor(props:any) {
      super(props)
      this.deletePressed = this.deletePressed.bind(this)
    }
    deletePressed() {this.props.deleteValue(this.props.arrayName, this.props.arrayIndex)}

    render() {

      let dropdown:any;
      if (this.props.showIntent) {
        if (this.props.intentOptions) {
          dropdown = <div className="intentRow"><Dropdown options={this.props.intentOptions} value={this.props.button.intent} onChange={this.props.onChange} name={this.props.arrayName + "." + this.props.arrayIndex + ".intent"} /></div>
        } else {
          dropdown = <div className="intentRow"><Spinner /></div>
        }
      }
      if (this.props.showVariables) {
        dropdown = <UserVariablesDropdown
        onChange={this.props.onChange}
        skipUserId={true}
        name={ this.props.arrayName + "." + this.props.arrayIndex + ".variableId"}
        value={this.props.button.variableId}
        />
      }


      return (
          <Draggable draggableId={"draggable_" + this.props.button.id} index={this.props.arrayIndex} >
            {
              (provided, snapshot) => (<div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                
                <div className="inspectorButton">
        <div className="buttonContent">
                <div className="buttonsItem buttonObj"><FaBars className="dragHandle" />
                <input className="buttonTitle" placeholder="Button text" value={this.props.button.text} name={this.props.arrayName + "." + this.props.arrayIndex + ".text"} onChange={this.props.onChange} />
                <span className="deleteButtonIcon" onClick={this.deletePressed}><FaMinusCircle/></span></div>
              </div>
              
        {dropdown}
        </div>

      </div>
              )
            }
          </Draggable>
);

    }
};
